import React from 'react';
import {
  Breadcrumbs,
  Typography,
  Box,
  Paper,
  CardMedia,
  makeStyles,
  createStyles,
  Avatar,
  Theme,
  Container,
  Grid,
  Chip,
  AppBar,
} from '@material-ui/core';
import { Link, Button } from 'gatsby-theme-material-ui';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { TrainerData } from '.';
import { nameRepresentation } from '../../utils/text-formatting';
import { TrainerDetails } from './trainer-details';
import { DiscountPromo } from '../../features/promo/discount-promo/discount-promo';
import { CheckList } from './check-list';
import { Price } from './price';
import { ActiveClients } from './active-clients';
import { CurrentViews } from './current-views';
import { ScrollPassWrapper, ScrollPassWrapperProps } from '../../components/scroll-pass-wrapper/scroll-pass.wrapper';

interface Props {
  trainerData: TrainerData;
  location: Location;
}

const useStyles = makeStyles(({ palette, spacing, breakpoints }: Theme) =>
  createStyles({
    appBar: {
      backgroundColor: palette.background.paper,
      '&.MuiAppBar-positionSticky': {
        top: 82,
        [breakpoints.down('sm')]: {
          top: 57
        }
      }
    },
    coverImage: {
      height: 209,
      borderTopRightRadius: 4,
      borderTopLeftRadius: 4,
    },
    avatar: {
      width: 180,
      height: 180,
      borderWidth: 4,
      borderColor: palette.primary.contrastText,
      marginTop: -150,
    },
    contentContainer: {
      marginTop: spacing(3.5),
      paddingBottom: spacing(7),
    },
  })
);

export const TrainerProfileDesktop: React.FC<Props> = ({ trainerData, location }) => {
  const name = nameRepresentation(
    trainerData.first_name,
    trainerData.last_name
  );

  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <Box mt={5} mb={5}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link color="inherit" to="/">
            Main
          </Link>
          <Link color="inherit" to="/trainers">
            Trainers
          </Link>
          <Typography color="textPrimary">{name}</Typography>
        </Breadcrumbs>
      </Box>
      <Paper>
        <CardMedia
          className={classes.coverImage}
          image={trainerData.cover_image_url}
        />
        <Container maxWidth="md">
          <Avatar
            className={classes.avatar}
            src={trainerData.profile_pic_url}
            alt={`${name} Profile Picture`}
          />
          <Grid container className={classes.contentContainer}>
            <Grid item sm={5}>
              <AppBar elevation={0} className={classes.appBar} position="sticky" color="default">
                <Box display="flex">
                  <Typography component="h1" variant="h5">{name}</Typography>
                  <Box mr={3} />
                  <Chip label="Verified" color="primary" size="medium" />
                </Box>
                <Box mt={2}>
                  <Typography variant="subtitle1">
                    {`${trainerData.available_spots} Available Spots Left`}
                  </Typography>
                  <Box mt={1} />
                  <ActiveClients trainerId={trainerData._id} />
                  <Box mt={2} />
                  <CurrentViews />
                  <Box mt={2} />
                  <CheckList />
                  <Box mt={3} />
                  <Price trainerId={trainerData._id} value={trainerData.price} />
                  <Box mt={3}>
                    <Button
                      to={`/membership/${trainerData._id}`}
                      color="primary"
                      variant="contained"
                      size="large"
                    >
                      START 7-DAY FREE TRIAL NOW
                    </Button>
                  </Box>
                  {/* <Box mt={8} />
                  <DiscountPromo justifyContent="flex-start" /> */}
                </Box>
              </AppBar>
            </Grid>
            <Grid item sm={7}>
              <TrainerDetails location={location} trainerData={trainerData} />
            </Grid>
          </Grid>
        </Container>
      </Paper>
      <Box mt={5} />
    </Container>
  );
};
